<div
  class="loading-container"
  *ngIf="initializer.initialLoading$ | async">
  <mat-spinner></mat-spinner>
</div>
